export default __webpack_public_path__ + "static/media/vivo.c9b9732f.svg";